<div class="dashboard--module-header">
    <h2 class="subheading-sm">High Consumption in last 60 days<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
    <issues-high-consumption-chart class="block-chart"></issues-high-consumption-chart>
    <div class="block-detail">
        <table class="std-table stacked-sm" *ngIf="data.length > 0">
            <thead>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>Supply</th>
            <th>Meter ID</th>
            <th>Average daily usage</th>
            <th>Site average daily usage</th>
            <th>Banding</th>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td data-label="Consumer name">{{item.consumerName}}</td>
                    <td data-label="Supply address">{{item.meterAddress}}</td>
                    <td data-label="Supply">{{item.supplyCategory}}</td>
                    <td data-label="Meter ID">{{item.serialNumber}}</td>
                    <td data-label="Average daily usage">{{item.averageDailyUsage | number:'1.3-3'}}</td>
                    <td data-label="Site average daily usage">{{item.aduMedian | number:'1.3-3'}}</td>
                    <td data-label="Banding">{{item.highConsumptionBanding}}</td>
                    <td *ngIf="clientId !== null" class="text-right"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
    </div>
</div>
